import React from "react";

export default function AboutBrief() {
    return (
        <section
            data-testid="section-about-brief"
            className="relative bg-[var(--paper)] py-24 md:py-32"
        >
            <div className="maxw section-pad">
                <div className="grid md:grid-cols-12 gap-10 items-end">
                    <div className="md:col-span-5">
                        <div className="eyebrow mb-5">About FreshEdge</div>
                        <div className="hr-line max-w-[140px]" />
                    </div>
                    <div className="md:col-span-7 reveal">
                        <h2 className="font-display font-light text-3xl sm:text-4xl md:text-5xl leading-[1.05] tracking-tight">
                            A local crew for{" "}
                            <span className="italic text-[var(--terra)]">
                                lawn, garden and outdoor work
                            </span>{" "}
                            — done properly.
                        </h2>
                        <p className="mt-6 text-[rgba(14,14,16,0.72)] text-base md:text-lg leading-relaxed max-w-2xl">
                            FreshEdge Services is a local property maintenance
                            business providing reliable lawn, garden, cleanup,
                            pressure washing, and outdoor maintenance services
                            across Queanbeyan, Canberra, Tuggeranong and
                            surrounding areas.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
